import _implicitStylesheets from "./filterModal.css";

import _implicitScopedStylesheets from "./filterModal.scoped.css?scoped=true";

import _myPicklist from "my/picklist";
import _lightningInput from "lightning/input";
import {registerTemplate, sanitizeAttribute} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {t: api_text, h: api_element, b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19} = $ctx;
  return [api_element("div", {
    classMap: {
      "slds-dropdown": true,
      "slds-nubbin_left-top": true,
      "slds-dropdown_left": true
    },
    attrs: {
      "data-my-id": "filterModal"
    },
    key: 0
  }, [api_element("ul", {
    classMap: {
      "slds-dropdown__list": true
    },
    attrs: {
      "role": "menu"
    },
    key: 1
  }, [api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 2
  }, [api_element("a", {
    attrs: {
      "href": "#",
      "role": "menuitem",
      "tabindex": "0"
    },
    key: 3
  }, [api_element("div", {
    classMap: {
      "slds-form-element": true
    },
    key: 4
  }, [api_element("label", {
    classMap: {
      "slds-form-element__label": true,
      "filters-text_align": true
    },
    key: 5
  }, [api_text("Filters")]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true,
      "clear-btn__align": true
    },
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClearFilter))
    }
  }, [api_text("Clear")])])])]), api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 7
  }, [api_element("a", {
    attrs: {
      "href": "#",
      "role": "menuitem",
      "tabindex": "0"
    },
    key: 8
  }, [api_element("div", {
    classMap: {
      "slds-form-element": true
    },
    key: 9
  }, [api_element("label", {
    classMap: {
      "slds-form-element__label": true
    },
    key: 10
  }, [api_text("Configuration / Developer Name")]), api_element("div", {
    classMap: {
      "slds-form-element__control": true,
      "slds-input-has-icon": true,
      "slds-input-has-icon_left-right": true,
      "input-text_width": true
    },
    key: 11
  }, [api_element("input", {
    classMap: {
      "slds-input": true,
      "filter-text_align": true
    },
    attrs: {
      "type": "text",
      "data-my-id": "configurationName",
      "placeholder": "Configuration / Developer Name"
    },
    props: {
      "value": $cmp.searchConfigName
    },
    key: 12,
    on: {
      "keyup": _m1 || ($ctx._m1 = api_bind($cmp.handleClearButton))
    }
  }, []), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_icon": true,
      "slds-input__icon": true,
      "slds-input__icon_right": true,
      "filter-btn_display": true
    },
    attrs: {
      "data-my-id": "configurationNameButton",
      "title": "Clear"
    },
    key: 13,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.clearConfValue))
    }
  }, [api_element("svg", {
    classMap: {
      "slds-button__icon": true,
      "slds-icon-text-light": true
    },
    attrs: {
      "aria-hidden": "true"
    },
    key: 14,
    svg: true
  }, [api_element("use", {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", "/SLDS/icons/utility-sprite/svg/symbols.svg#clear")
    },
    key: 15,
    svg: true
  }, [])]), api_element("span", {
    classMap: {
      "slds-assistive-text": true
    },
    key: 16
  }, [api_text("Clear")])])])])])]), api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 17
  }, [api_element("div", {
    classMap: {
      "slds-p-horizontal_small": true,
      "picklist-label_align": true
    },
    key: 18
  }, [api_element("label", {
    classMap: {
      "slds-form-element__label": true
    },
    key: 19
  }, [api_text("Modified By")]), api_custom_element("my-picklist", _myPicklist, {
    attrs: {
      "data-my-id": "modifiedBy"
    },
    props: {
      "options": $cmp.modifiedByOptions,
      "name": "modifiedBy",
      "inputValue": $cmp.modifiedByValue,
      "selectedValues": $cmp.selModifiedByValues,
      "allOptions": $cmp.modifiedByOptions
    },
    key: 20,
    on: {
      "valuechange": _m3 || ($ctx._m3 = api_bind($cmp.handleValueChange)),
      "enablefiltericonontypesel": _m4 || ($ctx._m4 = api_bind($cmp.enableFilterIconOnTypeSel)),
      "updatedpicklistvalue": _m5 || ($ctx._m5 = api_bind($cmp.handleUpdatedPicklistValue))
    }
  }, [])])]), api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 21
  }, [api_element("div", {
    classMap: {
      "slds-p-horizontal_small": true,
      "picklist-label_align": true
    },
    key: 22
  }, [api_element("label", {
    classMap: {
      "slds-form-element__label": true
    },
    key: 23
  }, [api_text("Type")]), api_custom_element("my-picklist", _myPicklist, {
    attrs: {
      "data-my-id": "compType"
    },
    props: {
      "options": $cmp.options,
      "name": "compType",
      "inputValue": $cmp.compTypeValue,
      "selectedValues": $cmp.selCompTypeValues,
      "allOptions": $cmp.options
    },
    key: 24,
    on: {
      "valuechange": _m6 || ($ctx._m6 = api_bind($cmp.handleValueChange)),
      "enablefiltericonontypesel": _m7 || ($ctx._m7 = api_bind($cmp.enableFilterIconOnTypeSel)),
      "updatedpicklistvalue": _m8 || ($ctx._m8 = api_bind($cmp.handleUpdatedCompTypePicklistValue))
    }
  }, [])])]), api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 25
  }, [api_element("div", {
    classMap: {
      "slds-p-horizontal_small": true,
      "picklist-label_align": true
    },
    key: 26
  }, [api_element("label", {
    classMap: {
      "slds-form-element__label": true
    },
    key: 27
  }, [api_text("Tags")]), api_custom_element("my-picklist", _myPicklist, {
    attrs: {
      "data-my-id": "tags"
    },
    props: {
      "options": $cmp.tagsOptions,
      "name": "tags",
      "inputValue": $cmp.tagsValue,
      "selectedValues": $cmp.selTagsValues,
      "allOptions": $cmp.tagsOptions
    },
    key: 28,
    on: {
      "valuechange": _m9 || ($ctx._m9 = api_bind($cmp.handleValueChange)),
      "enablefiltericonontypesel": _m10 || ($ctx._m10 = api_bind($cmp.enableFilterIconOnTypeSel)),
      "updatedpicklistvalue": _m11 || ($ctx._m11 = api_bind($cmp.handleUpdatedTagsPicklistValue))
    }
  }, [])])]), api_element("li", {
    classMap: {
      "slds-dropdown__item": true
    },
    attrs: {
      "role": "presentation"
    },
    key: 29
  }, [api_element("div", {
    classMap: {
      "slds-p-horizontal_small": true,
      "date-picker-position_align": true
    },
    key: 30
  }, [api_custom_element("lightning-input", _lightningInput, {
    classMap: {
      "picker-padding-right_align": true
    },
    attrs: {
      "data-my-id": "fromDate"
    },
    props: {
      "type": "date",
      "name": "fromDate",
      "label": "Modified From",
      "value": $cmp.searchFromDate,
      "dateStyle": "short",
      "max": $cmp.todaysDate,
      "messageWhenBadInput": $cmp.invalidDateFormatMsg
    },
    key: 31,
    on: {
      "change": _m12 || ($ctx._m12 = api_bind($cmp.enableFilterIconOnDateChange)),
      "blur": _m13 || ($ctx._m13 = api_bind($cmp.handleValidateDatePicker)),
      "click": _m14 || ($ctx._m14 = api_bind($cmp.handleClearButton))
    }
  }, []), api_custom_element("lightning-input", _lightningInput, {
    attrs: {
      "data-my-id": "toDate"
    },
    props: {
      "type": "date",
      "name": "toDate",
      "label": "Modified To",
      "value": $cmp.searchToDate,
      "dateStyle": "short",
      "max": $cmp.todaysDate,
      "messageWhenBadInput": $cmp.invalidDateFormatMsg
    },
    key: 32,
    on: {
      "change": _m15 || ($ctx._m15 = api_bind($cmp.enableFilterIconOnDateChange)),
      "blur": _m16 || ($ctx._m16 = api_bind($cmp.handleValidateDatePicker)),
      "click": _m17 || ($ctx._m17 = api_bind($cmp.handleClearButton))
    }
  }, [])])])]), api_element("footer", {
    classMap: {
      "footer-button_align": true
    },
    key: 33
  }, [api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_neutral": true,
      "cancel-btn_align": true
    },
    key: 34,
    on: {
      "click": _m18 || ($ctx._m18 = api_bind($cmp.closeFilterModalPopup))
    }
  }, [api_text("Cancel")]), api_element("button", {
    classMap: {
      "slds-button": true,
      "slds-button_brand": true,
      "apply-btn_align": true
    },
    attrs: {
      "data-my-id": "filterApplyButton"
    },
    key: 35,
    on: {
      "click": _m19 || ($ctx._m19 = api_bind($cmp.applyFilter))
    }
  }, [api_text("Apply")])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-filterModal_filterModal"
